import React from 'react';
import styles from './BrokerExpand.module.scss';

const BrokerExpand = ({ value, total, buttonContent, onClick, children }) => {
  return (
    <div className={`${styles.BrokerExpand} BrokerExpand`}>
      {children}
      <button
        className={`${styles.BrokerExpandButton}`}
        onClick={onClick}
        title={`${value}: ${total} brokers`}
      >
        {buttonContent}{' '}
      </button>
    </div>
  );
};

export default BrokerExpand;
